import script from "./ClientBlockPageContacts.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientBlockPageContacts.vue?vue&type=script&setup=true&lang=ts"

import "./ClientBlockPageContacts.vue?vue&type=style&index=0&id=5dc81587&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc81587"]])

export default __exports__